module.exports = __webpack_public_path__ + "static/img/cp_2.cc720f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/cp_2.png
// module id = ilNf
// module chunks = 1